// useViewport.ts — viewport breakpoints for the app shell. The design is
// desktop-first (pharmacy back office); `compact` collapses the sidebar into
// an overlay (< 1024px) and `phone` tightens chrome further (< 768px).
import { useEffect, useState } from 'react';

const COMPACT_QUERY = '(max-width: 1023px)';
const PHONE_QUERY = '(max-width: 767px)';

function matches(query: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false;
}

export function useViewport(): { compact: boolean; phone: boolean } {
  const [compact, setCompact] = useState(() => matches(COMPACT_QUERY));
  const [phone, setPhone] = useState(() => matches(PHONE_QUERY));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const compactMq = window.matchMedia(COMPACT_QUERY);
    const phoneMq = window.matchMedia(PHONE_QUERY);
    const onCompact = () => setCompact(compactMq.matches);
    const onPhone = () => setPhone(phoneMq.matches);
    compactMq.addEventListener('change', onCompact);
    phoneMq.addEventListener('change', onPhone);
    return () => {
      compactMq.removeEventListener('change', onCompact);
      phoneMq.removeEventListener('change', onPhone);
    };
  }, []);

  return { compact, phone };
}
